export const blockIconsContentInventory2 = (
	<span className='material-symbols-outlined'>inventory_2</span>
);
